// // import React, { useState, useEffect } from 'react';
// // import { BrowserRouter, Routes, Route, Navigate, Link, useLocation, useNavigate } from 'react-router-dom';
// // import { Layout, Menu, Button, Avatar, theme } from 'antd';
// // import {
// //   DashboardOutlined, ShopOutlined, TeamOutlined, ShoppingCartOutlined,
// //   SwapOutlined, TagOutlined, ReconciliationOutlined, DeleteOutlined,
// //   DollarOutlined, BarChartOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
// //   TruckOutlined,
// //   ToolOutlined,
// // } from '@ant-design/icons';
// // import './styles/global.css';

// // import Login from './pages/Login';
// // import Dashboard from './pages/Dashboard';
// // import Products from './pages/Products';
// // import Customers from './pages/Customers';
// // import Suppliers from './pages/Suppliers';
// // import Purchases from './pages/Purchases';
// // import Rentals from './pages/Rentals';
// // import RentalReturns from './pages/RentalReturns';
// // import Sales from './pages/Sales';
// // import Scrap from './pages/Scrap';
// // import Payments from './pages/Payments';
// // import Inventory from './pages/Inventory';
// // import ServiceCenter from './pages/ServiceCenter';

// // const { Sider, Header, Content } = Layout;

// // const menuItems = [
// //   { key: '/', icon: <DashboardOutlined />, label: 'Dashboard' },
// //   { key: '/products', icon: <ShopOutlined />, label: 'Products' },
// //   { key: '/customers', icon: <TeamOutlined />, label: 'Customers' },
// //   { key: '/suppliers', icon: <TruckOutlined />, label: 'Suppliers' },
// //   { key: 'stock', icon: <ReconciliationOutlined />, label: 'Stock', children: [
// //     { key: '/purchases', icon: <ShoppingCartOutlined />, label: 'Purchases (In)' },
// //     { key: '/inventory', icon: <BarChartOutlined />, label: 'Inventory' },
// //   ]},
// //   { key: 'transactions', icon: <SwapOutlined />, label: 'Transactions', children: [
// //     { key: '/rentals', icon: <TagOutlined />, label: 'Rentals' },
// //     { key: '/rental-returns', icon: <SwapOutlined />, label: 'Rental Returns' },
// //     { key: '/service-center', icon: <ToolOutlined />, label: 'Service Center' },
// //     { key: '/sales', icon: <DollarOutlined />, label: 'Sales' },
// //     { key: '/scrap', icon: <DeleteOutlined />, label: 'Scrap' },
// //   ]},
// //   { key: '/payments', icon: <DollarOutlined />, label: 'Payments' },
// // ];

// // function AppLayout() {
// //   const [collapsed, setCollapsed] = useState(false);
// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const user = JSON.parse(localStorage.getItem('user') || '{}');

// //   const logout = () => { localStorage.clear(); navigate('/login'); };

// //   const getSelectedKey = () => {
// //     return location.pathname === '/' ? '/' : location.pathname;
// //   };

// //   return (
// //     <Layout style={{ minHeight: '100vh' }}>
// //       <Sider width={220} collapsedWidth={56} collapsed={collapsed} theme="dark"
// //         style={{ position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 100, overflow: 'auto' }}>
// //         <div style={{ padding: collapsed ? '16px 8px' : '20px 16px', borderBottom: '1px solid var(--border)', marginBottom: 8 }}>
// //           {!collapsed ? (
// //             <div>
// //               <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent)', letterSpacing: '0.2em', textTransform: 'uppercase' }}>ShopMgr</div>
// //               <div style={{ fontFamily: 'var(--font-mono)', fontSize: 14, color: 'var(--text)', marginTop: 2 }}>v1.0</div>
// //             </div>
// //           ) : (
// //             <div style={{ fontFamily: 'var(--font-mono)', fontSize: 18, color: 'var(--accent)', textAlign: 'center' }}>S</div>
// //           )}
// //         </div>
// //         <Menu theme="dark" mode="inline" selectedKeys={[getSelectedKey()]}
// //           defaultOpenKeys={['stock', 'transactions']}
// //           onClick={({ key }) => navigate(key)}
// //           items={menuItems}
// //         />
// //       </Sider>
// //       <Layout style={{ marginLeft: collapsed ? 56 : 220, transition: 'margin-left 0.2s' }}>
// //         <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 99 }}>
// //           <Button type="text" icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
// //             onClick={() => setCollapsed(!collapsed)}
// //             style={{ color: 'var(--text-muted)', fontSize: 16 }}
// //           />
// //           <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
// //             <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)' }}>{user.fullName || user.username}</span>
// //             <Button type="text" icon={<LogoutOutlined />} onClick={logout} style={{ color: 'var(--text-muted)' }} />
// //           </div>
// //         </Header>
// //         <Content style={{ margin: 24, minHeight: 'calc(100vh - 112px)' }}>
// //           <Routes>
// //             <Route path="/" element={<Dashboard />} />
// //             <Route path="/products" element={<Products />} />
// //             <Route path="/customers" element={<Customers />} />
// //             <Route path="/suppliers" element={<Suppliers />} />
// //             <Route path="/purchases" element={<Purchases />} />
// //             <Route path="/rentals" element={<Rentals />} />
// //             <Route path="/rental-returns" element={<RentalReturns />} />
// //             <Route path="/service-center" element={<ServiceCenter />} />
// //             <Route path="/sales" element={<Sales />} />
// //             <Route path="/scrap" element={<Scrap />} />
// //             <Route path="/payments" element={<Payments />} />
// //             <Route path="/inventory" element={<Inventory />} />
// //           </Routes>
// //         </Content>
// //       </Layout>
// //     </Layout>
// //   );
// // }

// // function PublicRoute({ children }) {
// //   const token = localStorage.getItem('token');
// //   return token ? <Navigate to="/" replace /> : children;
// // }

// // function PrivateRoute({ children }) {
// //   const token = localStorage.getItem('token');
// //   return token ? children : <Navigate to="/login" replace />;
// // }

// // export default function App() {
// //   return (
// //     <BrowserRouter>
// //       <Routes>
// //         <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
// //         <Route path="/*" element={<PrivateRoute><AppLayout /></PrivateRoute>} />
// //       </Routes>
// //     </BrowserRouter>
// //   );
// // }

// import React, { useState, useEffect, createContext, useContext } from 'react';
// import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
// import { Layout, Menu, Button, ConfigProvider, theme as antTheme } from 'antd';
// import {
//   DashboardOutlined, ShopOutlined, TeamOutlined, ShoppingCartOutlined,
//   SwapOutlined, TagOutlined, ReconciliationOutlined, DeleteOutlined,
//   DollarOutlined, BarChartOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
//   TruckOutlined, ToolOutlined, SunOutlined, MoonOutlined,
// } from '@ant-design/icons';
// import './styles/global.css';

// import Login from './pages/Login';
// import Dashboard from './pages/Dashboard';
// import Products from './pages/Products';
// import Customers from './pages/Customers';
// import Suppliers from './pages/Suppliers';
// import Purchases from './pages/Purchases';
// import Rentals from './pages/Rentals';
// import RentalReturns from './pages/RentalReturns';
// import Sales from './pages/Sales';
// import Scrap from './pages/Scrap';
// import Payments from './pages/Payments';
// import Inventory from './pages/Inventory';
// import ServiceCenter from './pages/ServiceCenter';

// const { Sider, Header, Content } = Layout;

// export const ThemeContext = createContext({ isDark: true, toggleTheme: () => {} });

// const menuItems = [
//   { key: '/', icon: <DashboardOutlined />, label: 'Dashboard' },
//   { key: '/products', icon: <ShopOutlined />, label: 'Products' },
//   { key: '/customers', icon: <TeamOutlined />, label: 'Customers' },
//   { key: '/suppliers', icon: <TruckOutlined />, label: 'Suppliers' },
//   { key: 'stock', icon: <ReconciliationOutlined />, label: 'Stock', children: [
//     { key: '/purchases', icon: <ShoppingCartOutlined />, label: 'Purchases (In)' },
//     { key: '/inventory', icon: <BarChartOutlined />, label: 'Inventory' },
//   ]},
//   { key: 'transactions', icon: <SwapOutlined />, label: 'Transactions', children: [
//     { key: '/rentals', icon: <TagOutlined />, label: 'Rentals' },
//     { key: '/rental-returns', icon: <SwapOutlined />, label: 'Rental Returns' },
//     { key: '/service-center', icon: <ToolOutlined />, label: 'Service Center' },
//     { key: '/sales', icon: <DollarOutlined />, label: 'Sales' },
//     { key: '/scrap', icon: <DeleteOutlined />, label: 'Scrap' },
//   ]},
//   { key: '/payments', icon: <DollarOutlined />, label: 'Payments' },
// ];

// function AppLayout() {
//   const [collapsed, setCollapsed] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const user = JSON.parse(localStorage.getItem('user') || '{}');
//   const { isDark, toggleTheme } = useContext(ThemeContext);

//   const logout = () => { localStorage.clear(); navigate('/login'); };
//   const getSelectedKey = () => location.pathname === '/' ? '/' : location.pathname;

//   return (
//     <Layout style={{ minHeight: '100vh' }}>
//       <Sider
//         width={220} collapsedWidth={56} collapsed={collapsed}
//         theme={isDark ? 'dark' : 'light'}
//         style={{ position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 100, overflow: 'auto' }}
//       >
//         <div style={{ padding: collapsed ? '16px 8px' : '20px 16px', borderBottom: '1px solid var(--border)', marginBottom: 8 }}>
//           {!collapsed ? (
//             <div>
//               <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent)', letterSpacing: '0.2em', textTransform: 'uppercase' }}>ShopMgr</div>
//               <div style={{ fontFamily: 'var(--font-mono)', fontSize: 14, color: 'var(--text)', marginTop: 2 }}>v1.0</div>
//             </div>
//           ) : (
//             <div style={{ fontFamily: 'var(--font-mono)', fontSize: 18, color: 'var(--accent)', textAlign: 'center' }}>S</div>
//           )}
//         </div>
//         <Menu
//           theme={isDark ? 'dark' : 'light'}
//           mode="inline"
//           selectedKeys={[getSelectedKey()]}
//           defaultOpenKeys={['stock', 'transactions']}
//           onClick={({ key }) => navigate(key)}
//           items={menuItems}
//         />
//       </Sider>

//       <Layout style={{ marginLeft: collapsed ? 56 : 220, transition: 'margin-left 0.2s' }}>
//         <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 99 }}>
//           <Button
//             type="text"
//             icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//             onClick={() => setCollapsed(!collapsed)}
//             style={{ color: 'var(--text-muted)', fontSize: 16 }}
//           />
//           <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//             <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)' }}>
//               {user.fullName || user.username}
//             </span>
//             <Button
//               type="text"
//               icon={isDark ? <SunOutlined /> : <MoonOutlined />}
//               onClick={toggleTheme}
//               title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
//               style={{ color: isDark ? '#fadb14' : '#595959', fontSize: 16 }}
//             />
//             <Button type="text" icon={<LogoutOutlined />} onClick={logout} style={{ color: 'var(--text-muted)' }} />
//           </div>
//         </Header>
//         <Content style={{ margin: 24, minHeight: 'calc(100vh - 112px)' }}>
//           <Routes>
//             <Route path="/" element={<Dashboard />} />
//             <Route path="/products" element={<Products />} />
//             <Route path="/customers" element={<Customers />} />
//             <Route path="/suppliers" element={<Suppliers />} />
//             <Route path="/purchases" element={<Purchases />} />
//             <Route path="/rentals" element={<Rentals />} />
//             <Route path="/rental-returns" element={<RentalReturns />} />
//             <Route path="/service-center" element={<ServiceCenter />} />
//             <Route path="/sales" element={<Sales />} />
//             <Route path="/scrap" element={<Scrap />} />
//             <Route path="/payments" element={<Payments />} />
//             <Route path="/inventory" element={<Inventory />} />
//           </Routes>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// }

// function PublicRoute({ children }) {
//   const token = localStorage.getItem('token');
//   return token ? <Navigate to="/" replace /> : children;
// }

// function PrivateRoute({ children }) {
//   const token = localStorage.getItem('token');
//   return token ? children : <Navigate to="/login" replace />;
// }

// export default function App() {
//   const [isDark, setIsDark] = useState(() => localStorage.getItem('theme') !== 'light');

//   const toggleTheme = () => {
//     setIsDark(prev => {
//       const next = !prev;
//       localStorage.setItem('theme', next ? 'dark' : 'light');
//       document.documentElement.setAttribute('data-theme', next ? 'dark' : 'light');
//       return next;
//     });
//   };

//   useEffect(() => {
//     document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
//   }, [isDark]);

//   return (
//     <ThemeContext.Provider value={{ isDark, toggleTheme }}>
//       <ConfigProvider
//         theme={{
//           algorithm: isDark ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
//           token: {
//             colorPrimary: '#e94560',
//             colorLink: '#58a6ff',
//             borderRadius: 6,
//             fontFamily: '"IBM Plex Sans", sans-serif',
//           },
//         }}
//       >
//         <BrowserRouter>
//           <Routes>
//             <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
//             <Route path="/*" element={<PrivateRoute><AppLayout /></PrivateRoute>} />
//           </Routes>
//         </BrowserRouter>
//       </ConfigProvider>
//     </ThemeContext.Provider>
//   );
// }

// import React, { useState, useEffect } from 'react';
// import { BrowserRouter, Routes, Route, Navigate, Link, useLocation, useNavigate } from 'react-router-dom';
// import { Layout, Menu, Button, Avatar, theme } from 'antd';
// import {
//   DashboardOutlined, ShopOutlined, TeamOutlined, ShoppingCartOutlined,
//   SwapOutlined, TagOutlined, ReconciliationOutlined, DeleteOutlined,
//   DollarOutlined, BarChartOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
//   TruckOutlined,
//   ToolOutlined,
// } from '@ant-design/icons';
// import './styles/global.css';

// import Login from './pages/Login';
// import Dashboard from './pages/Dashboard';
// import Products from './pages/Products';
// import Customers from './pages/Customers';
// import Suppliers from './pages/Suppliers';
// import Purchases from './pages/Purchases';
// import Rentals from './pages/Rentals';
// import RentalReturns from './pages/RentalReturns';
// import Sales from './pages/Sales';
// import Scrap from './pages/Scrap';
// import Payments from './pages/Payments';
// import Inventory from './pages/Inventory';
// import ServiceCenter from './pages/ServiceCenter';

// const { Sider, Header, Content } = Layout;

// const menuItems = [
//   { key: '/', icon: <DashboardOutlined />, label: 'Dashboard' },
//   { key: '/products', icon: <ShopOutlined />, label: 'Products' },
//   { key: '/customers', icon: <TeamOutlined />, label: 'Customers' },
//   { key: '/suppliers', icon: <TruckOutlined />, label: 'Suppliers' },
//   { key: 'stock', icon: <ReconciliationOutlined />, label: 'Stock', children: [
//     { key: '/purchases', icon: <ShoppingCartOutlined />, label: 'Purchases (In)' },
//     { key: '/inventory', icon: <BarChartOutlined />, label: 'Inventory' },
//   ]},
//   { key: 'transactions', icon: <SwapOutlined />, label: 'Transactions', children: [
//     { key: '/rentals', icon: <TagOutlined />, label: 'Rentals' },
//     { key: '/rental-returns', icon: <SwapOutlined />, label: 'Rental Returns' },
//     { key: '/service-center', icon: <ToolOutlined />, label: 'Service Center' },
//     { key: '/sales', icon: <DollarOutlined />, label: 'Sales' },
//     { key: '/scrap', icon: <DeleteOutlined />, label: 'Scrap' },
//   ]},
//   { key: '/payments', icon: <DollarOutlined />, label: 'Payments' },
// ];

// function AppLayout() {
//   const [collapsed, setCollapsed] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const user = JSON.parse(localStorage.getItem('user') || '{}');

//   const logout = () => { localStorage.clear(); navigate('/login'); };

//   const getSelectedKey = () => {
//     return location.pathname === '/' ? '/' : location.pathname;
//   };

//   return (
//     <Layout style={{ minHeight: '100vh' }}>
//       <Sider width={220} collapsedWidth={56} collapsed={collapsed} theme="dark"
//         style={{ position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 100, overflow: 'auto' }}>
//         <div style={{ padding: collapsed ? '16px 8px' : '20px 16px', borderBottom: '1px solid var(--border)', marginBottom: 8 }}>
//           {!collapsed ? (
//             <div>
//               <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent)', letterSpacing: '0.2em', textTransform: 'uppercase' }}>ShopMgr</div>
//               <div style={{ fontFamily: 'var(--font-mono)', fontSize: 14, color: 'var(--text)', marginTop: 2 }}>v1.0</div>
//             </div>
//           ) : (
//             <div style={{ fontFamily: 'var(--font-mono)', fontSize: 18, color: 'var(--accent)', textAlign: 'center' }}>S</div>
//           )}
//         </div>
//         <Menu theme="dark" mode="inline" selectedKeys={[getSelectedKey()]}
//           defaultOpenKeys={['stock', 'transactions']}
//           onClick={({ key }) => navigate(key)}
//           items={menuItems}
//         />
//       </Sider>
//       <Layout style={{ marginLeft: collapsed ? 56 : 220, transition: 'margin-left 0.2s' }}>
//         <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 99 }}>
//           <Button type="text" icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//             onClick={() => setCollapsed(!collapsed)}
//             style={{ color: 'var(--text-muted)', fontSize: 16 }}
//           />
//           <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//             <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)' }}>{user.fullName || user.username}</span>
//             <Button type="text" icon={<LogoutOutlined />} onClick={logout} style={{ color: 'var(--text-muted)' }} />
//           </div>
//         </Header>
//         <Content style={{ margin: 24, minHeight: 'calc(100vh - 112px)' }}>
//           <Routes>
//             <Route path="/" element={<Dashboard />} />
//             <Route path="/products" element={<Products />} />
//             <Route path="/customers" element={<Customers />} />
//             <Route path="/suppliers" element={<Suppliers />} />
//             <Route path="/purchases" element={<Purchases />} />
//             <Route path="/rentals" element={<Rentals />} />
//             <Route path="/rental-returns" element={<RentalReturns />} />
//             <Route path="/service-center" element={<ServiceCenter />} />
//             <Route path="/sales" element={<Sales />} />
//             <Route path="/scrap" element={<Scrap />} />
//             <Route path="/payments" element={<Payments />} />
//             <Route path="/inventory" element={<Inventory />} />
//           </Routes>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// }

// function PublicRoute({ children }) {
//   const token = localStorage.getItem('token');
//   return token ? <Navigate to="/" replace /> : children;
// }

// function PrivateRoute({ children }) {
//   const token = localStorage.getItem('token');
//   return token ? children : <Navigate to="/login" replace />;
// }

// export default function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
//         <Route path="/*" element={<PrivateRoute><AppLayout /></PrivateRoute>} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

import React, { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Layout, Menu, Button, ConfigProvider, theme as antTheme } from 'antd';
import {
  DashboardOutlined, ShopOutlined, TeamOutlined, ShoppingCartOutlined,
  SwapOutlined, TagOutlined, ReconciliationOutlined, DeleteOutlined,
  DollarOutlined, BarChartOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
  TruckOutlined, ToolOutlined, SunOutlined, MoonOutlined,
} from '@ant-design/icons';
import './styles/global.css';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Customers from './pages/Customers';
import Suppliers from './pages/Suppliers';
import Purchases from './pages/Purchases';
import Rentals from './pages/Rentals';
import RentalReturns from './pages/RentalReturns';
import Sales from './pages/Sales';
import Scrap from './pages/Scrap';
import Payments from './pages/Payments';
import Inventory from './pages/Inventory';
import ServiceCenter from './pages/ServiceCenter';

const { Sider, Header, Content } = Layout;

export const ThemeContext = createContext({ isDark: true, toggleTheme: () => {} });

const menuItems = [
  { key: '/', icon: <DashboardOutlined />, label: 'Dashboard' },
  { key: '/products', icon: <ShopOutlined />, label: 'Products' },
  { key: '/customers', icon: <TeamOutlined />, label: 'Customers' },
  { key: '/suppliers', icon: <TruckOutlined />, label: 'Suppliers' },
  { key: 'stock', icon: <ReconciliationOutlined />, label: 'Stock', children: [
    { key: '/purchases', icon: <ShoppingCartOutlined />, label: 'Purchases (In)' },
    { key: '/inventory', icon: <BarChartOutlined />, label: 'Inventory' },
  ]},
  { key: 'transactions', icon: <SwapOutlined />, label: 'Transactions', children: [
    { key: '/rentals', icon: <TagOutlined />, label: 'Rentals' },
    { key: '/rental-returns', icon: <SwapOutlined />, label: 'Rental Returns' },
    { key: '/service-center', icon: <ToolOutlined />, label: 'Service Center' },
    { key: '/sales', icon: <DollarOutlined />, label: 'Sales' },
    { key: '/scrap', icon: <DeleteOutlined />, label: 'Scrap' },
  ]},
  { key: '/payments', icon: <DollarOutlined />, label: 'Payments' },
];

function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const { isDark, toggleTheme } = useContext(ThemeContext);

  const logout = () => { localStorage.clear(); navigate('/login'); };
  const getSelectedKey = () => location.pathname === '/' ? '/' : location.pathname;

  // Re-check auth on every navigation, since AppLayout stays mounted
  // across internal route changes and PrivateRoute only checks once on mount.
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      navigate('/login', { replace: true });
    }
  }, [location, navigate]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        width={220} collapsedWidth={56} collapsed={collapsed}
        theme={isDark ? 'dark' : 'light'}
        style={{ position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 100, overflow: 'auto' }}
      >
        <div style={{ padding: collapsed ? '16px 8px' : '20px 16px', borderBottom: '1px solid var(--border)', marginBottom: 8 }}>
          {!collapsed ? (
            <div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent)', letterSpacing: '0.2em', textTransform: 'uppercase' }}>RentalPRO</div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 14, color: 'var(--text)', marginTop: 2 }}>v1.0</div>
            </div>
          ) : (
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 18, color: 'var(--accent)', textAlign: 'center' }}>S</div>
          )}
        </div>
        <Menu
          theme={isDark ? 'dark' : 'light'}
          mode="inline"
          selectedKeys={[getSelectedKey()]}
          defaultOpenKeys={['stock', 'transactions']}
          onClick={({ key }) => navigate(key)}
          items={menuItems}
        />
      </Sider>

      <Layout style={{ marginLeft: collapsed ? 56 : 220, transition: 'margin-left 0.2s' }}>
        <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 99 }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ color: 'var(--text-muted)', fontSize: 16 }}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)' }}>
              {user.fullName || user.username}
            </span>
            <Button
              type="text"
              icon={isDark ? <SunOutlined /> : <MoonOutlined />}
              onClick={toggleTheme}
              title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
              style={{ color: isDark ? '#fadb14' : '#595959', fontSize: 16 }}
            />
            <Button type="text" icon={<LogoutOutlined />} onClick={logout} style={{ color: 'var(--text-muted)' }} />
          </div>
        </Header>
        <Content style={{ margin: 24, minHeight: 'calc(100vh - 112px)' }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/purchases" element={<Purchases />} />
            <Route path="/rentals" element={<Rentals />} />
            <Route path="/rental-returns" element={<RentalReturns />} />
            <Route path="/service-center" element={<ServiceCenter />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/scrap" element={<Scrap />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/inventory" element={<Inventory />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

function PublicRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? <Navigate to="/" replace /> : children;
}

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  const [isDark, setIsDark] = useState(() => localStorage.getItem('theme') !== 'light');

  const toggleTheme = () => {
    setIsDark(prev => {
      const next = !prev;
      localStorage.setItem('theme', next ? 'dark' : 'light');
      document.documentElement.setAttribute('data-theme', next ? 'dark' : 'light');
      return next;
    });
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <ConfigProvider
        theme={{
          algorithm: isDark ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
          token: {
            colorPrimary: '#e94560',
            colorLink: '#58a6ff',
            borderRadius: 6,
            fontFamily: '"IBM Plex Sans", sans-serif',
          },
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/*" element={<PrivateRoute><AppLayout /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </ThemeContext.Provider>
  );
}